<script lang="ts">
  import type { Component } from 'svelte';

  interface Props {
    icon: Component | string;
    size?: number;
    color?: string;
    strokeWidth?: number;
  }

  let { icon, size = 24, color = 'var(--icon-color, currentColor)', strokeWidth = 2 }: Props = $props();

  let isString = $derived(typeof icon === 'string');
  let iconWrapperEl: HTMLDivElement = $state();

  function toPascalCase(str: string): string {
    return str.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('');
  }

  $effect(() => {
    const currentIcon = icon;

    if (iconWrapperEl && isString && typeof lucide !== 'undefined') {
      let iconEl = iconWrapperEl.querySelector('i[data-lucide]');
      const iconData = lucide[toPascalCase(currentIcon as string)];

      if (iconData) {
        const svg = lucide.createElement(iconData);
        svg.setAttribute('width', String(size));
        svg.setAttribute('height', String(size));
        svg.setAttribute('stroke', color);
        svg.setAttribute('stroke-width', String(strokeWidth));
        iconEl.replaceWith(svg);
      }
    }
  });
</script>

<div bind:this={iconWrapperEl} class="icon">
  {#if isString}
    <i data-lucide={icon} style="width: {size}px; height: {size}px; color: {color};"></i>
  {:else}
    {@const Icon = icon}
    <Icon {size} {color} {strokeWidth} />
  {/if}
</div>

<style lang="scss">
  .icon {
    display: flex;
    width: fit-content;
    align-items: center;
    justify-content: center;
  }
</style>
